<template>
  <div class="dialog-box">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="配置信息" name="config">
        <div>
          <p class="device-row">
            <span>设备编号:</span><span>{{ deviceId }}</span>
          </p>
          <p class="device-row">
            <span>在线状态:</span>
            <span style="color: #01d34b" v-if="online == 2">在线</span>
            <span style="color: #f53929" v-else>离线</span>
          </p>
          <div class="config-box">
            <el-form ref="configForm" :model="configForm" :inline="true">
              <el-form-item prop="configVer" label="配置版本">
                <el-input
                  v-model="configForm.configVer"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="iovdcKey" label="iovdc_key">
                <el-input
                  v-model="configForm.iovdcKey"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="updateKeyId" label="升级包秘钥ID">
                <el-input
                  v-model="configForm.updateKeyId"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="updateKey" label="升级包秘钥(hex)">
                <el-input
                  v-model="configForm.updateKey"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="vin" label="车架号">
                <el-input
                  v-model="configForm.vin"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="callNum" label="SIM卡电话号码">
                <el-input
                  v-model="configForm.callNum"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="eCallNum" label="Ecall服务号码">
                <el-input
                  v-model="configForm.eCallNum"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="bCallNum" label="Bcall服务号码">
                <el-input
                  v-model="configForm.bCallNum"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="iCallNum" label="Icall服务号码">
                <el-input
                  v-model="configForm.iCallNum"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="eCallSmsNum" label="Ecall短信号码">
                <el-input
                  v-model="configForm.eCallSmsNum"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="apnName" label="apn接入名称">
                <el-input
                  v-model="configForm.apnName"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="iovdcIp1" label="接入服务器ip1">
                <el-input
                  v-model="configForm.iovdcIp1"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="iovdcIp2" label="接入服务器ip2">
                <el-input
                  v-model="configForm.iovdcIp2"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="iovdcIp3" label="接入服务器ip3">
                <el-input
                  v-model="configForm.iovdcIp3"
                  placeholder="请输入"
                  :disabled="configDisabled"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item prop="noticeModel" label="最近升级日期">
                <el-input
                  v-model="configForm.noticeModel"
                  placeholder="请输入"
                ></el-input>
              </el-form-item> -->
              <div class="btn-box">
                <el-button type="primary" @click="configEdit">编辑</el-button>
                <el-button type="primary" @click="configSave">保存</el-button>
                <el-button type="primary" @click="configRead">读取</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="陀螺仪校正" name="gyro">
        <div>
          <p class="device-row">
            <span>设备编号:</span><span>{{ deviceId }}</span>
          </p>
          <p class="device-row">
            <span>在线状态:</span>
            <span style="color: #01d34b" v-if="online == 2">在线</span>
            <span style="color: #f53929" v-else>离线</span>
          </p>
          <div class="gyro-box">
            <el-form ref="gyroForm" :model="gyroForm" :inline="true">
              <el-form-item prop="xangle" label="X方向姿态角度校正">
                <el-input
                  v-model="gyroForm.xangle"
                  placeholder="请输入"
                  :disabled="gyroDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="yangle" label="Y方向姿态角度校正">
                <el-input
                  v-model="gyroForm.yangle"
                  placeholder="请输入"
                  :disabled="gyroDisabled"
                ></el-input>
              </el-form-item>
              <el-form-item prop="driveAngle" label="行驶方向姿态角度校正">
                <el-input
                  v-model="gyroForm.driveAngle"
                  placeholder="请输入"
                  :disabled="gyroDisabled"
                ></el-input>
              </el-form-item>
              <div class="btn-box">
                <el-button type="primary" @click="gyroEdit">编辑</el-button>
                <el-button type="primary" @click="gyroSave">保存</el-button>
                <el-button type="primary" @click="gyroRead">读取</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="注册应答" name="register">
        <div>
          <p class="device-row">
            <span>设备编号:</span><span>{{ deviceId }}</span>
          </p>
          <p class="device-row">
            <span>在线状态:</span>
            <span style="color: #01d34b" v-if="online == 2">在线</span>
            <span style="color: #f53929" v-else>离线</span>
          </p>
          <div class="respond-box">
            <el-form ref="respondForm" :model="respondForm" :inline="true">
              <el-form-item prop="friendlyDeviceNetwork" label="设备互联网络">
                <el-select
                  v-model="respondForm.friendlyDeviceNetwork"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in netWork"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="customerWiFiNetwork" label="用户WIFI网络">
                <el-select
                  v-model="respondForm.customerWiFiNetwork"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in netWork"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="eCallLimit" label="E_call通话时长（分钟）">
                <el-input
                  v-model="respondForm.eCallLimit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item prop="bCallLimit" label="B_call通话时长（分钟）">
                <el-input
                  v-model="respondForm.bCallLimit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item prop="iCallLimit" label="I_call通话时长（分钟）">
                <el-input
                  v-model="respondForm.iCallLimit"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item prop="otherCall" label="其他通话时长（分钟）">
                <el-input
                  v-model="respondForm.otherCall"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
              <el-form-item prop="electricCutOffTime" label="发电截止时间">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="respondForm.electricCutOffTime"
                  type="datetime"
                  placeholder="发电截止时间"
                ></el-date-picker>
              </el-form-item>
              <div class="btn-box">
                <el-button type="primary" @click="respondSave">保存</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="设备重启" name="restart">
        <div>
          <p class="device-row">
            <span>设备编号:</span><span>{{ deviceId }}</span>
          </p>
          <p class="device-row">
            <span>在线状态:</span>
            <span style="color: #01d34b" v-if="online == 2">在线</span>
            <span style="color: #f53929" v-else>离线</span>
          </p>
          <div class="btn-box">
            <el-button type="primary" @click="restartSave">设备重启</el-button>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="设备激活" name="activate">
        <div>
          <p class="device-row">
            <span>设备编号:</span><span>{{ deviceId }}</span>
          </p>
          <p class="device-row">
            <span>在线状态:</span>
            <span style="color: #01d34b" v-if="online == 2">在线</span>
            <span style="color: #f53929" v-else>离线</span>
          </p>
          <div class="gyro-box active-box">
            <div style="margin-bottom:20px">
              <span class="active-label">设备当前状态</span>
              <span class="active-con">{{ activation }}</span>
            </div>
            <el-form ref="activeForm" :model="activeForm" :inline="true">
              <el-form-item class="r-20" prop="expireTime" label="激活截止时间">
                <el-date-picker
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="activeForm.expireTime"
                  type="datetime"
                  placeholder="激活截止时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item prop="activation" label="设备激活">
                <el-select v-model="activeForm.activation" placeholder="请选择">
                  <el-option label="激活" :value="1">激活</el-option>
                  <el-option label="反激活" :value="0">反激活</el-option>
                </el-select>
              </el-form-item>
              <div class="btn-box">
                <el-button type="primary" @click="activeSave">确定</el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "RemoveOperate",
  props: {
    deviceId: {
      type: String,
      required: true,
    },
    online: {
      type: Number,
      required: true,
    },
    modelCode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeName: "config",
      configForm: {},
      configDisabled: true,
      gyroForm: {},
      gyroDisabled: true,
      respondForm: {},
      netWork: [
        {
          label: "关闭",
          id: 0,
        },
        {
          label: "开启WIFI",
          id: 1,
        },
        {
          label: "开启3G",
          id: 2,
        },
        {
          label: "开启WIFI与3G",
          id: 3,
        },
      ],
      activation: "--",
      activeForm: {},
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name == "activate") {
        this.activeRead()
      }
    },
    //配置信息
    configEdit() {
      this.configDisabled = false
    },
    async configSave() {
      let _this = this
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/config",
        this.configForm
      )
      if (res.code == 1) {
        _this.$message.success("操作成功")
        _this.configDisabled = true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async configRead() {
      this.configDisabled = true
      let _this = this
      let obj = {
        deviceId: _this.deviceId,
        modelCode: _this.modelCode,
        millisecond: "1",
        ts: _this.$nowDate(),
      }
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/config/read",
        obj
      )
      if (res.code == 1) {
        _this.configForm = res.data
        _this.$message.success("操作成功")
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //陀螺仪校正
    gyroEdit() {
      this.gyroDisabled = false
    },
    async gyroSave() {
      let _this = this
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/gyro/adjust",
        _this.gyroForm
      )
      if (res.code == 1) {
        _this.$message.success("操作成功")
        _this.gyroDisabled = true
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async gyroRead() {
      this.gyroDisabled = true
      let _this = this
      let obj = {
        deviceId: _this.deviceId,
        modelCode: _this.modelCode,
        millisecond: "1",
        ts: _this.$nowDate(),
      }
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/gyro/adjust",
        obj
      )
      if (res.code == 1) {
        _this.gyroForm = res.data
        _this.$message.success("操作成功")
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //注册应答
    async respondSave() {
      let _this = this
      _this.respondForm.deviceId = _this.deviceId
      _this.respondForm.modelCode = _this.modelCode
      _this.respondForm.millisecond = "1"
      _this.respondForm.ts = _this.$nowDate()
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/register",
        _this.respondForm
      )
      if (res.code == 1) {
        _this.$message.success("操作成功")
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //设备重启
    async restartSave() {
      let _this = this
      let obj = {
        deviceId: _this.deviceId,
        modelCode: _this.modelCode,
        millisecond: "1",
        ts: _this.$nowDate(),
      }
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/reset/command",
        obj
      )
      if (res.code == 1) {
        _this.$message.success("操作成功")
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //设备激活
    async activeRead() {
      let _this = this
      let obj = {
        deviceId: _this.deviceId,
        modelCode: _this.modelCode,
        millisecond: "1",
        ts: _this.$nowDate(),
      }
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/activation/read",
        obj
      )
      if (res.code == 1) {
        _this.activation = res.data.activation == 1 ? "已激活" : "未激活"
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async activeSave() {
      let _this = this
      let obj = {
        activation: _this.activeForm.activation,
        expireTime: _this.activeForm.expireTime,
        deviceId: _this.deviceId,
        modelCode: _this.modelCode,
        millisecond: "1",
        ts: _this.$nowDate(),
      }
      let { data: res } = await _this.$axios.post(
        "/api/device/remote/activation",
        obj
      )
      if (res.code == 1) {
        _this.$message.success("操作成功")
      } else {
        _this.$message.warning(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-box {
  font-size: 14px;
  color: #333;
}
.device-row {
  line-height: 28px;
  span:first-child {
    margin-right: 8px;
  }
}
//配置信息
.config-box /deep/ {
  margin-top: 30px;
  .el-form > div {
    width: 33%;
  }
  .el-form .el-form-item__label {
    width: 128px;
    line-height: 34px;
    padding-left: 0;
    padding-right: 20px;
    text-align: right;
    margin-left: 0;
  }
  .el-form .el-form-item__content {
    width: 240px;
  }
  .el-form--inline .el-form-item {
    margin-right: 0;
  }
}
//陀螺仪校正
.gyro-box /deep/ {
  margin-top: 30px;
  .el-form > div {
    width: 80%;
  }
  .el-form .el-form-item__label {
    width: 166px;
    line-height: 34px;
    padding-left: 0;
    padding-right: 20px;
    text-align: right;
    margin-left: 0;
  }
  .el-form .el-form-item__content {
    width: 310px;
  }
}
//注册应答
.respond-box /deep/ {
  margin-top: 30px;
  .el-form > div {
    width: 46%;
  }
  .el-form .el-form-item__label {
    width: 210px;
    line-height: 34px;
    padding-left: 0;
    padding-right: 20px;
    text-align: right;
    margin-left: 0;
  }
  .el-form .el-form-item__content {
    width: 310px;
  }
  .el-date-editor {
    width: 100% !important;
  }
}
//设备激活
.active-box /deep/ .el-date-editor {
  width: 100% !important;
}
.active-label {
  display: inline-block;
  width: 166px;
  line-height: 34px;
  padding-left: 0;
  padding-right: 20px;
  text-align: right;
  margin-left: 0;
  box-sizing: border-box;
}
.btn-box {
  width: 100% !important;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 8px;
}
</style>
